import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/promo-codes",
    name: "Promos",
    component: () => import("./promoCodeAdmin.vue"),
  },
  {
    path: "/page-content-manager",
    name: "Content Manager",
    component: () => import("./contentManagerListing.vue"),
  },
  {
    //':pageContentMapId' is 'new' while the designer is still building a mapping that has no row.
    path: "/page-content-manager/:pageContentMapId",
    name: "Visual Content Designer",
    component: () => import("./contentDesignerPage.vue"),
  },
  {
    path: "/cohorts",
    name: "Cohorts",
    component: () => import("./cohortAdmin.vue"),
  },
  {
    path: "/bamal",
    name: "BAMAL",
    component: () => import("./bamal.vue"),
  },
  {
    path: "/columbia-invoice",
    name: "Columbia Gas Bill Message",
    component: () => import("./columbiaBillMessage.vue"),
  },
  {
    path: "/invoice-marketing",
    name: "Invoice Marketing",
    component: () => import("./choiceInvoiceMarketing.vue"),
  },
  {
    path: "/campaigns",
    name: "Campaign Manager",
    component: () => import("./campaignManager.vue"),
  },
  {
    path: "/campaigns/:previewType/:slug",
    name: "Campaign Preview",
    component: () => import("./campaignPreview.vue"),
    props: true,
  },
  {
    path: "/marketing-notification-stats",
    name: "Marketing Notification Stats",
    component: () => import("../marketing/marketingNotificationStatsPage.vue"),
  },
] satisfies RouteRecordRaw[];
